<template>
    <div name="health-measurement-consent">
        <h2>건강측정정보 의료진 제공 동의</h2>
        <span>솔닥 주식회사(이하 "회사")는 이용자의 건강상담 지원을 위해, 이용자가 본 진료 예약 건에 대하여 동의하고 선택한 건강측정정보를 예진 자료(예진지) 형태로 의료진에게 제공합니다.</span><br><br>
        <table class="table" border="1">
            <thead>
                <tr>
                    <th style="width: 18%;">제공받는 자</th>
                    <th style="width: 22%;">제공 목적</th>
                    <th style="width: 37%;">제공 항목</th>
                    <th style="width: 23%;">제공받는 자의 보유 및 이용기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>솔닥 제휴 의료진 및 해당 의료기관</td>
                    <td>건강상담 지원 및 진료 참고자료(예진지) 제공</td>
                    <td>측정일자, 신장, 체중, 골격근량, 체지방량, 체지방률, BMI, 혈압(최저/최고 혈압, 맥박수), 악력(왼손, 오른손)</td>
                    <td>「의료법」 등 관련 법령에서 정한 진료기록 보존기간까지</td>
                </tr>
            </tbody>
        </table>
        <span><br>※ 위 정보는 건강측정정보 연동 진료 예약 서비스 제공에 필요한 필수 항목입니다. 동의를 거부하실 경우 본 서비스 이용이 제한되며, 건강측정정보를 제공하지 않는 일반 진료 예약으로 진행하실 수 있습니다.</span>
    </div>
</template>

<script>
export default {
    name: 'healthMeasurementConsent'
}
</script>

<style scoped>
    .table {
      width: 100%;
      border-collapse: collapse;
      word-break: break-word;
    }
    th, td {
      padding: 8px;
      vertical-align: top;
      text-align: left;
    }
    th {
      background-color: #f4f4f4;
      font-weight: bold;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/HealthMeasurementConsent.vue